import { useEffect, useState } from "react";
import { Alert, Center, Container, Loader, Stack, Text } from "@mantine/core";
import { Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { api } from "../api/client";

/** Resolves /sh/:code → /shipments/:id by looking up the code via search. */
export function ShipmentByCode() {
  const { t } = useTranslation();
  const { code = "" } = useParams<{ code: string }>();
  const [shipmentId, setShipmentId] = useState<number | "not_found" | null>(null);

  useEffect(() => {
    const clean = code.trim().replace(/^:+/, "").replace(/[:!]+$/, "");
    if (!clean) {
      setShipmentId("not_found");
      return;
    }
    api
      .listShipments({ q: clean })
      .then((rows) => {
        const exact = rows.find((s) => s.code.toLowerCase() === clean.toLowerCase());
        setShipmentId(exact ? exact.id : "not_found");
      })
      .catch(() => setShipmentId("not_found"));
  }, [code]);

  if (shipmentId === null) {
    return (
      <Center mih={300}>
        <Stack align="center" gap="xs">
          <Loader />
          <Text c="dimmed">{t("shipmentByCode.loading", { code })}</Text>
        </Stack>
      </Center>
    );
  }
  if (shipmentId === "not_found") {
    return (
      <Container size="sm" mt="xl">
        <Alert color="red" title={t("shipmentByCode.notFoundTitle")}>
          {t("shipmentByCode.notFoundBody", { code })}
        </Alert>
      </Container>
    );
  }
  return <Navigate to={`/shipments/${shipmentId}`} replace />;
}
